import React, { useState, useEffect } from "react";
import AllBlogs from "../AllBlogs";
import axios from 'axios';
import { G_API, PAGE_LIMIT } from '../../constants/globalVar';
import PageSlider from '../PageSlider';
import { useParams } from "react-router-dom";
import AllEvents from "../AllEvents";
import AllCourses from "../AllCourses";

const TagPage = ({ tagOf, apiEnd }) => {
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const paramTag = useParams();

  const [tags, setTags] = useState([]);

  useEffect(() => {
    setLoading(true);
    axios.post(`${G_API}${apiEnd}`, {
      page: currentPage,
      limit: PAGE_LIMIT,
      tag: paramTag.tag ?? "",
    })
      .then((response) => {
        const items = response.data.DATAS || [];
        const current = response.data.CURRENT_PAGE || 1;
        const last = response.data.LAST_PAGE || 1;

        setItems(items);
        setCurrentPage(current);
        setLastPage(last);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });

    axios.get(`${G_API}tags/TAGS_LIST`)
      .then((response) => {
        const tags = response.data.DATAS || [];
        setTags(tags);
      })
      .catch((error) => {
        console.error("Error fetching tags:", error);
      });
  }, [currentPage, paramTag.tag, apiEnd]);

  return (
    <>
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" >
        <div className="carousel-inner" >
          <PageSlider inputType={`${tagOf} Tag ~ ${paramTag.tag}`} />
        </div>
      </div>

      <section id="tags" className="py-3 px-5">
        <div>
          <span className="opacity-50">Tags: </span>
          <span>
            {((tags != null) ? tags.map((tag, index) => (
              <a key={index} className="badge bg-secondary me-1 text-decoration-none" href={tag.title ? `/${tagOf}s/tags/${tag.title}` : "#"}>
                {tag.title}
              </a>
            )) : null)}
          </span>
        </div>
      </section>

      <section id="course">
        <div className="container-xxl my-5 py-5">
          <div className="container py-5">
            <div className="row g-4 justify-content-center list">
              {loading ? (
                <div className="text-center my-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="item">
                  {items.map((item) => {
                    if (tagOf === 'event') {
                      return <AllEvents key={item.id} item={item} style={{
                        width: "calc(33.33% - 20px)",
                        margin: "20px",
                        textAlign: "center"
                      }} />;
                    }
                    if (tagOf === 'course') {
                      return <AllCourses key={item.id} item={item} style={{
                        width: "calc(33.33% - 20px)",
                        margin: "20px",
                        textAlign: "center"
                      }} />;
                    }

                    return <AllBlogs key={item.id} item={item} style={{
                      width: "calc(33.33% - 20px)",
                      margin: "20px",
                      textAlign: "center"
                    }} />;
                  })}
                </div>
              )}
            </div>

            {/* Pagination */}
            <div className={`d-flex justify-content-center mt-4 ${lastPage === 1 ? 'd-none' : ''}`}>
              <nav>
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 || loading ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                      Previous
                    </button>
                  </li>

                  {Array.from({ length: lastPage }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === lastPage || loading ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, lastPage))} disabled={loading} >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default TagPage;
